import { useState } from 'react';

function useLocalStorage(key, defaultValue) {
  const [value, setValueState] = useState(() => {
    try {
      const stored = localStorage.getItem(key);
      if (stored === null) return defaultValue;
      return JSON.parse(stored);
    } catch {
      return defaultValue;
    }
  });

  const setValue = (newValue) => {
    setValueState(newValue);
    try {
      localStorage.setItem(key, JSON.stringify(newValue));
    } catch {
      // ignore write errors (e.g. private browsing quota)
    }
  };

  return [value, setValue];
}

export default useLocalStorage;
